<template>
  <CBox class="codingHandleContainer" mt="15vw">
    <CBox
      w="100%"
      d="flex"
      justifyContent="center"
      mt="9vw"
      mx="auto"
      mb="1.5vw"
    >
      <CBox
        class="codingHandleButtons"
        d="flex"
        width="40vw"
        justifyContent="space-evenly"
      >
        <CBox
          m="1vw"
          p="0.5vw"
          w="100%"
          fontSize="1vw"
          color="#3E7C17"
          borderRadius="0.5vw"
          textAlign="center"
          class="codingHandleButton turnToPointer"
          outline="1px solid #3E7C17"
          @click="redirectToHackerRank"
        >
          HackerRank
        </CBox>
        <CBox
          m="1vw"
          p="0.5vw"
          w="100%"
          fontSize="1vw"
          color="#091353"
          borderRadius="0.5vw"
          textAlign="center"
          class="codingHandleButton turnToPointer"
          outline="1px solid #091353"
          @click="redirectToGitHub"
        >
          GitHub
        </CBox>
        <CBox
          m="1vw"
          p="0.5vw"
          w="100%"
          fontSize="1vw"
          color="#F05454"
          borderRadius="0.5vw"
          textAlign="center"
          class="codingHandleButton turnToPointer"
          outline="1px solid #F05454"
          @click="redirectToLeetCode"
        >
          LeetCode
        </CBox>
      </CBox>
    </CBox>
  </CBox>
</template>

<script>
import { CBox } from "@chakra-ui/vue";

export default {
  name: "CodingHandles",
  components: {
    CBox,
  },
  methods: {
    redirectToHackerRank() {
      window.open("https://www.hackerrank.com/khirasariyak", "_blank");
    },
    redirectToLeetCode() {
      window.open("https://leetcode.com/khirasariyak/", "_blank");
    },
    redirectToGitHub() {
      window.open("https://github.com/kishankhirasariya", "_blank");
    },
  },
};
</script>

<style>
@media screen and (max-width: 480px) {
  .codingHandleContainer {
    margin-top: 12vh;
  }
  .codingHandleButtons {
    width: 70vw;
  }
  .codingHandleButton {
    font-size: 2vw;
    padding: 1.25vw;
    margin: 2vw;
  }
}

/* @media screen and (max-width: 480px) {
   .mediaButtons {
    width: 80vw;
  }
  .mediaButton {
    font-size: 2vw;
    padding: 1vw;
    margin: 4vw;
  }
  .bottomHeading {
    font-size: 2vw;
    margin-bottom: 5vw;
  }
} */

.turnToPointer {
  cursor: pointer;
}

.turnToPointer:hover {
  outline-style: dotted;
  font-weight: bold;
}
</style>
